import { AfterViewInit, Component, ElementRef, EventEmitter, HostBinding, HostListener, Inject, Input, OnInit } from '@angular/core';
import { PortalWidgetType } from 'src/app/models/enums/PortalWidgetType';
import { DOCUMENT } from '@angular/common';
import { DataService } from 'src/app/shared/services/data.service';
import { RenderService } from 'src/app/shared/services/render.service';
import { RouterService } from 'src/app/shared/services/router.service';
import { environment } from 'src/environments/environment';
import { CurrentPageService } from 'src/app/shared/services/current-page.service';
import { laptopLayoutMediaQuery, matchesMediaQuery } from 'src/app/utils/helpers/mediaQueryHelper';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss','./home-page.component.en.scss'],
})
export class HomePageComponent implements OnInit {
  openedMessages: EventEmitter<boolean> = new EventEmitter<boolean>();
  openedAssignments: EventEmitter<boolean> = new EventEmitter<boolean>();
  openedRequests: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() emptyPage: boolean = false;
  @HostBinding('style.--grid-height') gridHeight: string = 'auto';

  @HostListener('window:resize')
  onResize() {
    this.setLayoutState();
    // this.calcGridHeight();
  }

  @Input() pageUrl: string | unknown;
  PortalWidgetType = PortalWidgetType;

  mobileTrigerWigetsState: any = {
    assignmentMobileBlockData: {
      exists: false,
      count: 0,
      title: '',
      loading: true,
      allLinkUrl: null, 
      allLinkText: '', 
      allLinkTarget: ''
    },
    messagesMobileBlockData: {
      exists: false,
      count: 0,
      title: '',
      loading: true,
      allLinkUrl: null, 
      allLinkText: '', 
      allLinkTarget: ''
    },
    requestsMobileBlockData: {
      exists: false,
      count: 0,
      title: '',
      loading: true,
      allLinkUrl: null, 
      allLinkText: '', 
      allLinkTarget: ''
    }
  }

  pageData!: any;
  mobileHeaderWidgets: any[] = [];

  isLaptopLayout: boolean = false;
  laptopRightWidgetGrid: any[] = [];
  laptopLeftWidgetGrid: any[] = [];

  constructor(
    private dataService: DataService,
    private routerService: RouterService,
    private renderService: RenderService,
    private currentPageService: CurrentPageService,
    @Inject(DOCUMENT) private document: Document,
    private el: ElementRef,
  ) {}

  ngOnInit(): void {
    this.setLayoutState();
    this.getPageData();
  }

  getPageData() {
    const searchRequest: any = {
      pageUrl: this.pageUrl ?? this.routerService.getCurrentComponentRoute(),
      cultureCode: this.dataService.getCultureCode(),
    };

    let url = environment.apiUrl + '/Portal/Api/Home/Index';
    this.dataService.getDataByToken(url, searchRequest).subscribe({
      next: (result) => {
        this.pageData = result;
        this.setLaptopWidgetGrids();

        this.dataService.currentPageNodeId = this.pageData.pageId;
        this.currentPageService.setCurrentPageNodeId(this.pageData.pageId);
        this.checkHeadersWidgets();
        this.checkMobileWidgets();
        this.renderService.bindMainScripts();
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  setLayoutState(): void {
    this.isLaptopLayout = matchesMediaQuery(laptopLayoutMediaQuery);
  }

  setLaptopWidgetGrids(): void {
    this.laptopRightWidgetGrid = this.pageData?.laptopRightWidgetGrid ?? [];
    this.laptopLeftWidgetGrid = this.pageData?.laptopLeftWidgetGrid ?? [];
  }

  getAllWidgets(): any[] {
    return [
      ...(this.pageData?.centralWidgetGrid ?? []),
      ...(this.pageData?.leftWidgetGrid ?? []),
      ...(this.pageData?.rightWidgetGrid ?? []),
    ];
  }

  checkHeadersWidgets() {
    this.mobileHeaderWidgets = this.getAllWidgets().filter(
      (widget: any) => widget.type == PortalWidgetType.WidgetSingleArticle
    );
  }

  checkMobileWidgets() {
    const allWidgets = this.getAllWidgets();

    this.mobileTrigerWigetsState.assignmentMobileBlockData.exists = 
      allWidgets.some(x => x.type == PortalWidgetType.WidgetAssignments);

    const messagesWidget = allWidgets.find((x: any) => x.type == PortalWidgetType.WidgetMessages);
    this.mobileTrigerWigetsState.messagesMobileBlockData.exists = !!messagesWidget;
    
    if (messagesWidget) {
      this.mobileTrigerWigetsState.messagesMobileBlockData.allLinkUrl = messagesWidget.data.allLinkUrl;
      this.mobileTrigerWigetsState.messagesMobileBlockData.allLinkText = messagesWidget.data.allLinkText;
      this.mobileTrigerWigetsState.messagesMobileBlockData.allLinkTarget = messagesWidget.data.allLinkTarget;
    }

    const requestsWidget = allWidgets.find((x: any) => x.type == PortalWidgetType.WidgetRequestsAndProcesses);
    this.mobileTrigerWigetsState.requestsMobileBlockData.exists = !!requestsWidget;
    
    if (requestsWidget) {
      this.mobileTrigerWigetsState.requestsMobileBlockData.allLinkUrl = requestsWidget.data.allLinkUrl;
      this.mobileTrigerWigetsState.requestsMobileBlockData.allLinkText = requestsWidget.data.allLinkText;
      this.mobileTrigerWigetsState.requestsMobileBlockData.allLinkTarget = requestsWidget.data.allLinkTarget;
    }
  }

  ngAfterViewInit() {
    // setTimeout(() => {
    //   this.calcGridHeight();
    // }, 500)
  }

  toggleMessages(state: boolean) {
    this.openedMessages.emit(state);
    this.toggleBodyClass(state);
  }

  toggleAssignments(state: boolean) {
    this.openedAssignments.emit(state);
    this.toggleBodyClass(state);
  }

  toggleRequests(state: boolean) {
    this.openedRequests.emit(state);
    this.toggleBodyClass(state);
  }

  toggleBodyClass(state: boolean) {
    if (state) {
      this.document.body.classList.add('opened-modal');
    } else {
      this.document.body.classList.remove('opened-modal');
    }
  }

  widgetLoaded() {
    // setTimeout(() => {
    //   this.calcGridHeight();
    // }, 80);
  }

  calcGridHeight() {
    const column1 = this.el.nativeElement.querySelectorAll('.column-1');
    const column2 = this.el.nativeElement.querySelectorAll('.column-2');
    let column1Height = 0;
    let column2Height = 0;

    column1.forEach((el: any, i: number) => {
      column1Height += el.offsetHeight + ((i > 0) ? 24 : 1);
    });
    column2.forEach((el: any, i: number) => {
      column2Height += el.offsetHeight + ((i > 0) ? 24 : 1);
    });
    
    this.gridHeight = Math.max(column1Height, column2Height) + 'px';
  }

  getGridOrderSettings(widget: any, column: number, orderlaptop: number): any {
    return {
      widget: widget,
      column: column,
      orderlaptop: (column * 100) + orderlaptop + 1,
    }
  }

  setAssignmentData(data: any) {
    this.mobileTrigerWigetsState.assignmentMobileBlockData = data;
  }

  setMessagesData(data: any) {
    this.mobileTrigerWigetsState.messagesMobileBlockData = data;
  }

  setRequestsData(data: any) {
    this.mobileTrigerWigetsState.requestsMobileBlockData = data;
  }
}
